import { Romcal } from 'romcal';
import { GeneralRoman_Es } from '@romcal/calendar.general-roman';

export const ROMCAL_VERSION = '3.0.0-dev.140';

/**
 * Calendario usado por Desideria en Colombia.
 *
 * La Conferencia Episcopal de Colombia traslada al domingo:
 * - Epifanía: domingo entre el 2 y el 8 de enero;
 * - Ascensión: VII Domingo de Pascua;
 * - Corpus Christi: domingo después de la Santísima Trinidad.
 *
 * Romcal aplica además las consecuencias de esas reglas al Propio del Tiempo
 * (por ejemplo, el Bautismo del Señor después de la Epifanía).
 */
export function createGeneralRomanCalendar() {
  return new Romcal({
    scope: 'gregorian',
    localizedCalendar: GeneralRoman_Es,
    epiphanyOnSunday: true,
    ascensionOnSunday: true,
    corpusChristiOnSunday: true,
  });
}
